import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useLanguage } from '../context/LanguageContext';
import { useTheme } from '../context/ThemeContext';
import { useModules } from '../context/ModulesContext';
import { NotificationsPanel } from './NotificationsPanel';
import { LanguageSelector } from './LanguageSelector';
import { BottomNav } from './BottomNav';
import { MobileHeader } from './MobileHeader';
import GlobalSearch from './GlobalSearch';
import NotificationBell from './NotificationBell';
import { useState } from 'react';
import {
  LayoutDashboard,
  Users,
  Briefcase,
  FileText,
  DollarSign,
  UsersRound,
  PackageOpen,
  FileBarChart,
  LogOut,
  Menu,
  X,
  Shield,
  Database,
  Settings,
  Truck,
  FileCheck,
  ScrollText,
  Package,
  Wallet,
  Clock,
  Factory,
  BarChart3,
  Bell,
  Calendar,
  Palette,
  Megaphone,
  Star,
  Share2,
  Tag,
  CreditCard,
  ChevronDown,
  ChevronLeft,
  Building2,
  Banknote,
  UserCog,
  TrendingUp,
  TrendingDown,
  Wrench,
  Mail,
  ExternalLink,
  Headphones,
  Receipt,
  ListTodo,
  Timer,
  UserPlus,
  ShoppingCart,
  Coffee,
  PieChart,
  Box,
  Send,
  Printer,
  CheckCircle,
  Sun,
  Moon,
  MessageCircle,
  Zap,
  Target,
  Server,
  CalendarClock,
  BellRing,
  RefreshCw,
  Sparkles,
  Brain,
  Ticket,
  DoorOpen,
  FileSignature,
  MessageSquare,
  Presentation,
  GitBranch,
  FolderOpen,
  LayoutTemplate,
  Layers,
  CalendarDays,
  Bot,
  Mic,
  Instagram,
  Gift,
  Trophy,
  PartyPopper,
  Radio,
  Camera,
  UserCheck,
  GraduationCap,
  Gamepad2,
  Heart,
  Copyright,
  Wrench as WrenchIcon,
  AlertTriangle,
  Percent,
  Share,
  Globe,
  Video,
  FileEdit,
  Languages,
  Rocket,
  MapPin,
  Car,
  Activity,
  CalendarCheck,
  Archive,
  BookOpen,
  Calculator,
  Search
} from 'lucide-react';
import { Button } from './ui/button';

// الصلاحيات الافتراضية لكل دور
const DEFAULT_PERMISSIONS = {
  admin: ['dashboard', 'clients', 'projects', 'invoices', 'expenses', 'employees', 'services', 'reports', 'delivery', 'quotations', 'contracts', 'inventory', 'suppliers', 'payroll', 'attendance', 'analytics', 'notifications', 'calendar', 'designs', 'campaigns', 'reviews', 'bank', 'social', 'offers', 'whatsapp', 'users_management', 'audit_log', 'backup', 'documentation', 'support_tickets', 'company_settings', 'taxes', 'tasks', 'time_tracking', 'leads', 'purchase_orders', 'charts_analytics', 'assets', 'email_campaigns', 'print_orders', 'print_settings', 'approvals', 'files', 'ai_tools', 'advanced_tools', 'security_integration', 'business_management', 'user_experience', 'tenders', 'events', 'outdoor_ads', 'studio_booking', 'influencers', 'training', 'gamification', 'loyalty', 'ip_management', 'equipment', 'complaints', 'commissions', 'referrals', 'web_projects', 'video_production', 'content_management', 'translation', 'launches', 'bookings', 'installments', 'client_kpis', 'annual_comparison', 'archive', 'suggestions_complaints', 'live_kpi', 'brand_guidelines', 'maintenance', 'internal_review', 'sop', 'smart_pricing', 'okr', 'project_profitability', 'admin', 'settings', 'office_services'],
  admin_dept_manager: ['dashboard', 'calendar', 'notifications', 'employees', 'attendance', 'payroll', 'tasks', 'time_tracking', 'approvals', 'reports', 'documentation', 'support_tickets', 'files', 'training', 'gamification', 'suggestions_complaints', 'ai_tools', 'office_services'],
  finance_dept_manager: ['dashboard', 'calendar', 'notifications', 'invoices', 'quotations', 'contracts', 'expenses', 'payments', 'bank', 'taxes', 'reports', 'analytics', 'charts_analytics', 'offers', 'commissions', 'installments', 'archive', 'ai_tools', 'office_services'],
  audit_dept_manager: ['dashboard', 'calendar', 'notifications', 'audit_log', 'reports', 'analytics', 'charts_analytics', 'approvals', 'files', 'documentation', 'internal_review', 'ai_tools', 'office_services'],
  design_dept_manager: ['dashboard', 'calendar', 'notifications', 'clients', 'projects', 'tasks', 'campaigns', 'social', 'designs', 'reviews', 'email_campaigns', 'video_production', 'content_management', 'web_projects', 'launches', 'influencers', 'outdoor_ads', 'brand_guidelines', 'ai_tools', 'office_services'],
  print_dept_manager: ['dashboard', 'calendar', 'notifications', 'print_orders', 'inventory', 'suppliers', 'purchase_orders', 'assets', 'equipment', 'clients', 'projects', 'reports', 'ai_tools', 'office_services'],
  delivery_dept_manager: ['dashboard', 'calendar', 'notifications', 'delivery', 'clients', 'reports', 'tasks', 'ai_tools', 'office_services'],
  inventory_dept_manager: ['dashboard', 'calendar', 'notifications', 'inventory', 'suppliers', 'purchase_orders', 'assets', 'equipment', 'delivery', 'reports', 'ai_tools', 'office_services'],
  authorized_manager: ['dashboard', 'clients', 'projects', 'invoices', 'expenses', 'employees', 'services', 'reports', 'delivery', 'quotations', 'contracts', 'inventory', 'suppliers', 'payroll', 'attendance', 'analytics', 'notifications', 'calendar', 'designs', 'campaigns', 'reviews', 'bank', 'social', 'offers', 'whatsapp', 'users_management', 'audit_log', 'backup', 'documentation', 'tasks', 'time_tracking', 'leads', 'purchase_orders', 'charts_analytics', 'assets', 'email_campaigns', 'print_orders', 'print_settings', 'approvals', 'files', 'ai_tools', 'advanced_tools', 'security_integration', 'business_management', 'user_experience', 'tenders', 'events', 'outdoor_ads', 'studio_booking', 'influencers', 'training', 'gamification', 'loyalty', 'ip_management', 'equipment', 'complaints', 'commissions', 'referrals', 'web_projects', 'video_production', 'content_management', 'translation', 'launches', 'bookings', 'installments', 'client_kpis', 'annual_comparison', 'archive', 'suggestions_complaints', 'live_kpi', 'brand_guidelines', 'maintenance', 'internal_review', 'sop', 'smart_pricing', 'okr', 'project_profitability', 'office_services'],
  deputy_manager: ['dashboard', 'clients', 'projects', 'invoices', 'expenses', 'employees', 'services', 'reports', 'delivery', 'quotations', 'contracts', 'inventory', 'suppliers', 'payroll', 'attendance', 'analytics', 'notifications', 'calendar', 'designs', 'campaigns', 'reviews', 'bank', 'social', 'offers', 'whatsapp', 'users_management', 'audit_log', 'backup', 'documentation', 'support_tickets', 'company_settings', 'taxes', 'tasks', 'time_tracking', 'leads', 'purchase_orders', 'charts_analytics', 'assets', 'email_campaigns', 'print_orders', 'print_settings', 'approvals', 'files', 'ai_tools', 'advanced_tools', 'security_integration', 'business_management', 'user_experience', 'tenders', 'events', 'outdoor_ads', 'studio_booking', 'influencers', 'training', 'gamification', 'loyalty', 'ip_management', 'equipment', 'complaints', 'commissions', 'referrals', 'web_projects', 'video_production', 'content_management', 'translation', 'launches', 'bookings', 'installments', 'client_kpis', 'annual_comparison', 'archive', 'suggestions_complaints', 'live_kpi', 'brand_guidelines', 'maintenance', 'internal_review', 'sop', 'smart_pricing', 'okr', 'project_profitability', 'admin', 'settings', 'office_services'],
  supervisor: ['dashboard', 'clients', 'projects', 'quotations', 'contracts', 'invoices', 'delivery', 'expenses', 'services', 'reports', 'analytics', 'reviews', 'calendar', 'notifications', 'whatsapp', 'tasks', 'time_tracking', 'leads', 'purchase_orders', 'assets', 'print_orders', 'user_experience', 'tenders', 'events', 'complaints', 'suggestions_complaints', 'maintenance', 'sop', 'office_services'],
  admin_staff: ['dashboard', 'clients', 'employees', 'attendance', 'calendar', 'notifications', 'tasks', 'assets', 'print_orders', 'user_experience', 'complaints', 'office_services'],
  admin_assistant: ['dashboard', 'clients', 'employees', 'calendar', 'notifications', 'tasks', 'print_orders', 'office_services'],
  accountant: ['dashboard', 'clients', 'invoices', 'expenses', 'bank', 'payroll', 'reports', 'analytics', 'time_tracking', 'purchase_orders', 'charts_analytics', 'assets', 'office_services'],
  accountant_assistant: ['dashboard', 'invoices', 'expenses', 'bank', 'reports', 'purchase_orders', 'office_services'],
  data_entry: ['dashboard', 'clients', 'projects', 'inventory', 'suppliers', 'tasks', 'purchase_orders', 'print_orders', 'office_services'],
  inventory: ['dashboard', 'inventory', 'suppliers', 'delivery', 'purchase_orders', 'assets', 'print_orders', 'office_services'],
  payroll: ['dashboard', 'employees', 'attendance', 'payroll', 'time_tracking', 'office_services'],
  designer: ['dashboard', 'projects', 'designs', 'campaigns', 'social', 'tasks', 'email_campaigns', 'print_orders', 'user_experience', 'office_services'],
  admin_employee: ['dashboard', 'clients', 'employees', 'attendance', 'calendar', 'tasks', 'print_orders', 'office_services'],
  driver: ['delivery']  // السائق يستخدم بوابة السائقين المخصصة فقط
};

// تحديد من يمكنه رؤية صفحات الإدارة
const canAccessAdminPages = (role, permissions) => {
  const adminRoles = ['admin', 'authorized_manager', 'deputy_manager'];
  if (adminRoles.includes(role)) return true;
  if (permissions?.includes('users_management') || permissions?.includes('audit_log') || permissions?.includes('backup') || permissions?.includes('documentation')) return true;
  return false;
};

// مكون القائمة الفرعية القابلة للطي
const CollapsibleSection = ({ icon: Icon, titleKey, children, defaultOpen = false, hasActiveChild }) => {
  const [isOpen, setIsOpen] = useState(defaultOpen || hasActiveChild);
  const { t, isRTL } = useLanguage();

  return (
    <div className="mb-1">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`w-full flex items-center justify-between px-4 py-2.5 rounded-md font-cairo transition-all duration-200 ${
          hasActiveChild ? 'bg-blue-800/50 text-white' : 'hover:bg-blue-700/50 text-blue-100'
        }`}
        data-testid={`section-${titleKey}`}
      >
        <div className="flex items-center gap-3">
          <Icon size={18} className="text-accent" />
          <span className="font-medium text-sm">{t(titleKey)}</span>
        </div>
        {isRTL ? (
          <ChevronLeft size={16} className={`transition-transform duration-200 ${isOpen ? '-rotate-90' : ''}`} />
        ) : (
          <ChevronDown size={16} className={`transition-transform duration-200 ${isOpen ? '' : '-rotate-90'}`} />
        )}
      </button>
      <div className={`overflow-hidden transition-all duration-300 ${isOpen ? 'max-h-[800px] opacity-100' : 'max-h-0 opacity-0'}`}>
        <ul className="mt-1 mr-4 space-y-1 border-r-2 border-blue-700/50 pr-2">
          {children}
        </ul>
      </div>
    </div>
  );
};

// مكون عنصر القائمة
const MenuItem = ({ path, icon: Icon, labelKey, label, isActive, onClick }) => {
  const { t } = useLanguage();

  return (
    <li>
      <Link
        to={path}
        className={`flex items-center gap-3 px-3 py-2 rounded-md font-cairo transition-all duration-200 text-sm ${
          isActive
            ? 'bg-accent text-slate-900 shadow-md'
            : 'hover:bg-blue-700 hover:shadow-sm text-white/90'
        }`}
        onClick={onClick}
        data-testid={`sidebar-${path.replace('/', '') || 'home'}-link`}
      >
        <Icon size={18} />
        <span className="font-medium">{label || t(labelKey)}</span>
      </Link>
    </li>
  );
};

export const Sidebar = ({ isOpen: externalIsOpen, setIsOpen: externalSetIsOpen }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const { t, isRTL } = useLanguage();
  const { isPermissionActive } = useModules();
  const [internalIsOpen, setInternalIsOpen] = useState(false);
  
  // استخدام الحالة الخارجية إذا كانت متوفرة
  const isOpen = externalIsOpen !== undefined ? externalIsOpen : internalIsOpen;
  const setIsOpen = externalSetIsOpen || setInternalIsOpen;

  // دالة الحصول على اسم الدور
  const getRoleName = (role) => {
    const roleKeys = {
      'admin': 'roleAdmin',
      'admin_dept_manager': 'مدير القسم الإداري',
      'finance_dept_manager': 'مدير القسم المالي',
      'audit_dept_manager': 'مدير قسم التدقيق',
      'design_dept_manager': 'مدير قسم التصميم',
      'print_dept_manager': 'مدير قسم الطباعة',
      'delivery_dept_manager': 'مدير قسم التوصيل',
      'inventory_dept_manager': 'مدير قسم المخزن',
      'authorized_manager': 'roleAuthorizedManager',
      'deputy_manager': 'roleDeputyManager',
      'supervisor': 'roleSupervisor',
      'admin_staff': 'roleAdminStaff',
      'admin_assistant': 'roleAdminAssistant',
      'accountant': 'roleAccountant',
      'accountant_assistant': 'roleAccountantAssistant',
      'data_entry': 'roleDataEntry',
      'inventory': 'roleInventory',
      'payroll': 'rolePayroll',
      'designer': 'roleDesigner',
      'admin_employee': 'roleAdminEmployee'
    };
    return roleKeys[role] ? t(roleKeys[role]) : role;
  };

  // التحقق من الصلاحيات
  const hasPermission = (permission) => {
    // null/undefined permission means: open to everyone
    if (!permission) return true;
    const roleDefaults = DEFAULT_PERMISSIONS[user?.role] || [];
    const userPermissions = user?.permissions || roleDefaults;
    // Merge user permissions with role defaults to catch newly added permissions
    const allPermissions = [...new Set([...userPermissions, ...roleDefaults])];
    return user?.role === 'admin' || user?.role === 'deputy_manager' || allPermissions.includes(permission);
  };

  // التحقق من وجود عنصر نشط في المجموعة
  const hasActiveInGroup = (paths) => {
    return paths.some(p => location.pathname === p);
  };

  // الأقسام المجمّعة
  const menuGroups = {
    main: [
      { path: '/', icon: LayoutDashboard, labelKey: 'dashboard', permission: 'dashboard' },
      { path: '/executive-dashboard', icon: TrendingUp, labelKey: 'executiveDashboard', permission: 'reports' },
      { path: '/calendar', icon: Calendar, labelKey: 'calendar', permission: 'calendar' },
      { path: '/archive', icon: Archive, labelKey: 'archive', permission: 'archive' },
      { path: '/live-kpi', icon: Activity, labelKey: 'liveKPI', permission: 'live_kpi' },
    ],
    clients: {
      titleKey: 'clientsAndProjects',
      icon: Building2,
      items: [
        { path: '/clients', icon: Users, labelKey: 'clients', permission: 'clients' },
        { path: '/projects', icon: Briefcase, labelKey: 'projects', permission: 'projects' },
        { path: '/project-templates', icon: LayoutTemplate, labelKey: 'projectTemplates', permission: 'projects' },
        { path: '/kanban', icon: LayoutDashboard, labelKey: 'kanban', permission: 'projects' },
        { path: '/tasks', icon: ListTodo, labelKey: 'tasks', permission: 'tasks' },
        { path: '/time-tracking', icon: Timer, labelKey: 'timeTracking', permission: 'time_tracking' },
        { path: '/leads', icon: UserPlus, labelKey: 'leads', permission: 'leads' },
        { path: '/quotations', icon: FileCheck, labelKey: 'quotations', permission: 'quotations' },
        { path: '/contracts', icon: ScrollText, labelKey: 'contracts', permission: 'contracts' },
        { path: '/e-signature', icon: FileSignature, labelKey: 'eSignature', permission: 'contracts' },
        { path: '/presentations', icon: Presentation, labelKey: 'presentations', permission: 'quotations' },
        { path: '/services', icon: Wrench, labelKey: 'services', permission: 'services' },
        { path: '/reviews', icon: Star, labelKey: 'reviews', permission: 'reviews' },
        { path: '/client-kpis', icon: Target, labelKey: 'clientKPIs', permission: 'client_kpis' },
        { path: '/brand-guidelines', icon: Palette, labelKey: 'brandGuidelines', permission: 'brand_guidelines' },
        { path: '/suggestions-complaints', icon: MessageSquare, labelKey: 'suggestionsComplaints', permission: 'suggestions_complaints' },
        { path: '/support-tickets', icon: Headphones, labelKey: 'supportTickets', permission: 'support_tickets' },
        { path: '/files', icon: FolderOpen, labelKey: 'files', permission: 'files' },
        { path: '/digital-assets', icon: FolderOpen, labelKey: 'digitalAssets', permission: 'files' },
      ]
    },
    finance: {
      titleKey: 'finance',
      icon: Banknote,
      items: [
        { path: '/invoices', icon: FileText, labelKey: 'invoices', permission: 'invoices' },
        { path: '/invoice-reminders', icon: Bell, labelKey: 'invoiceReminders', permission: 'invoices' },
        { path: '/auto-invoice', icon: Zap, labelKey: 'autoInvoice', permission: 'invoices' },
        { path: '/payments', icon: CreditCard, labelKey: 'payments', permission: 'invoices' },
        { path: '/payment-transactions', icon: Globe, labelKey: 'paymentTransactions', permission: 'invoices' },
        { path: '/subscriptions', icon: RefreshCw, labelKey: 'subscriptions', permission: 'invoices' },
        { path: '/expenses', icon: DollarSign, labelKey: 'expenses', permission: 'expenses' },
        { path: '/expense-tracking', icon: TrendingDown, labelKey: 'expenseTracking', permission: 'expenses' },
        { path: '/taxes', icon: Receipt, labelKey: 'taxes', permission: 'taxes' },
        { path: '/bank-accounts', icon: Wallet, labelKey: 'bankAccounts', permission: 'bank' },
        { path: '/offers', icon: Gift, labelKey: 'offers', permission: 'offers' },
        { path: '/installments', icon: CreditCard, labelKey: 'installments', permission: 'installments' },
        { path: '/financial-reports', icon: FileBarChart, labelKey: 'financialReports', permission: 'reports' },
        { path: '/advanced-financial-reports', icon: BarChart3, labelKey: 'advancedReports', permission: 'reports' },
        { path: '/annual-comparison', icon: BarChart3, labelKey: 'annualComparison', permission: 'annual_comparison' },
        { path: '/smart-pricing', icon: Calculator, labelKey: 'smartPricing', permission: 'smart_pricing' },
        { path: '/project-profitability', icon: BarChart3, labelKey: 'projectProfitability', permission: 'project_profitability' },
      ]
    },
    inventory: {
      titleKey: 'inventoryAndSuppliers',
      icon: Package,
      items: [
        { path: '/inventory', icon: Package, labelKey: 'inventory', permission: 'inventory' },
        { path: '/suppliers', icon: Factory, labelKey: 'suppliers', permission: 'suppliers' },
        { path: '/purchase-orders', icon: ShoppingCart, labelKey: 'purchaseOrders', permission: 'purchase_orders' },
        { path: '/assets', icon: Box, labelKey: 'assets', permission: 'assets' },
        { path: '/maintenance-schedule', icon: Wrench, labelKey: 'maintenanceSchedule', permission: 'maintenance' },
      ]
    },
    printing: {
      titleKey: 'printing',
      icon: Printer,
      items: [
        { path: '/print-orders', icon: Printer, labelKey: 'printOrders', permission: 'print_orders' },
        { path: '/client-print-requests', icon: Printer, label: 'طلبات طباعة العملاء', permission: 'print_orders' },
        { path: '/customer-tracking', icon: Search, label: 'تتبع طلبات العملاء', permission: 'clients' },
        { path: '/print-profit-reports', icon: TrendingUp, labelKey: 'printProfitReports', permission: 'print_orders' },
        { path: '/print-settings', icon: Settings, labelKey: 'printSettings', permission: 'print_settings' },
      ]
    },
    delivery: {
      titleKey: 'deliveryAndDrivers',
      icon: Truck,
      items: [
        { path: '/delivery', icon: Truck, labelKey: 'delivery', permission: 'delivery' },
        { path: '/delivery-orders', icon: PackageOpen, labelKey: 'deliveryOrders', permission: 'delivery' },
        { path: '/driver-tracking', icon: MapPin, labelKey: 'driverTracking', permission: 'delivery' },
        { path: '/driver-performance', icon: BarChart3, labelKey: 'driverPerformance', permission: 'delivery' },
        { path: '/driver-leaderboard', icon: Trophy, labelKey: 'driverLeaderboard', permission: 'delivery' },
        { path: '/drivers-management', icon: UserCog, labelKey: 'driversManagement', permission: 'delivery' },
        { path: '/delivery-photos', icon: Camera, labelKey: 'deliveryPhotos', permission: 'delivery' },
        { path: '/driver-ratings', icon: Star, labelKey: 'driverRatings', permission: 'delivery' },
        { path: '/cash-collection', icon: DollarSign, labelKey: 'cashCollection', permission: 'delivery' },
        { path: '/zones', icon: Globe, labelKey: 'zones', permission: 'delivery' },
        { path: '/fleet', icon: Car, labelKey: 'fleet', permission: 'delivery' },
        { path: '/driver-mobile', icon: Truck, labelKey: 'driverPortal', permission: 'delivery' },
      ]
    },
    hr: {
      titleKey: 'humanResources',
      icon: UserCog,
      items: [
        { path: '/employees', icon: UsersRound, labelKey: 'employees', permission: 'employees' },
        { path: '/attendance', icon: Clock, labelKey: 'attendance', permission: 'attendance' },
        { path: '/payroll', icon: PackageOpen, labelKey: 'payroll', permission: 'payroll' },
        { path: '/employee-kpi', icon: Target, labelKey: 'employeeKPI', permission: 'employees' },
        { path: '/company-kpis', icon: Activity, labelKey: 'companyKPIs', permission: 'admin' },
        { path: '/leaves', icon: Calendar, labelKey: 'leaves', permission: 'employees' },
        { path: '/leave-management', icon: CalendarDays, labelKey: 'leaveManagement', permission: 'employees' },
        { path: '/leave-reports', icon: FileText, labelKey: 'leaveReports', permission: 'employees' },
        { path: '/resource-planning', icon: Layers, labelKey: 'resourcePlanning', permission: 'employees' },
        { path: '/rewards', icon: Star, labelKey: 'rewards', permission: 'employees' },
      ]
    },
    marketing: {
      titleKey: 'marketing',
      icon: Megaphone,
      items: [
        { path: '/campaigns', icon: Megaphone, labelKey: 'campaigns', permission: 'campaigns' },
        { path: '/designs', icon: Palette, labelKey: 'designs', permission: 'designs' },
        { path: '/design-reviews', icon: MessageCircle, labelKey: 'designReviews', permission: 'designs' },
        { path: '/portfolio', icon: Briefcase, labelKey: 'portfolio', permission: 'designs' },
        { path: '/social-media', icon: Instagram, labelKey: 'socialMedia', permission: 'social' },
        { path: '/email-marketing', icon: Mail, labelKey: 'emailMarketing', permission: 'email_campaigns' },
        { path: '/customer-surveys', icon: Star, labelKey: 'customerSurveys', permission: 'reviews' },
        { path: '/email-campaigns', icon: Send, labelKey: 'emailCampaigns', permission: 'email_campaigns' },
        { path: '/whatsapp', icon: Bell, labelKey: 'whatsapp', permission: 'whatsapp' },
      ]
    },
    ai: {
      titleKey: 'aiTools',
      icon: Sparkles,
      items: [
        { path: '/ai-dashboard', icon: Brain, labelKey: 'aiDashboard', permission: 'ai_tools' },
        { path: '/ai-assistant', icon: MessageCircle, labelKey: 'aiAssistant', permission: 'ai_tools' },
        { path: '/ai-forecast', icon: TrendingUp, labelKey: 'aiForecast', permission: 'ai_tools' },
      ]
    },
    advancedTools: {
      titleKey: 'advancedTools',
      icon: Zap,
      items: [
        { path: '/user-experience', icon: Mic, labelKey: 'userExperience', permission: 'user_experience' },
        { path: '/ai-features', icon: Brain, labelKey: 'aiFeatures', permission: 'ai_tools' },
        { path: '/business-management', icon: Briefcase, labelKey: 'businessManagement', permission: 'business_management' },
        { path: '/security-integration', icon: Shield, labelKey: 'securityIntegration', permission: 'security_integration' },
        { path: '/notifications', icon: Bell, labelKey: 'notifications', permission: 'notifications' },
        { path: '/notifications-system', icon: BellRing, labelKey: 'notificationsSystem', permission: 'notifications' },
        { path: '/notification-settings', icon: Settings, labelKey: 'notificationSettings', permission: 'settings' },
      ]
    },
    reports: {
      titleKey: 'reportsAndAnalytics',
      icon: TrendingUp,
      items: [
        { path: '/advanced-dashboard', icon: LayoutDashboard, labelKey: 'advancedDashboard', permission: 'reports' },
        { path: '/executive-dashboard', icon: Target, labelKey: 'executiveDashboard', permission: 'reports' },
        { path: '/unified-reports', icon: FileBarChart, labelKey: 'unifiedReports', permission: 'reports' },
        { path: '/team-performance', icon: Users, labelKey: 'teamPerformance', permission: 'reports' },
        { path: '/performance-reports', icon: FileText, labelKey: 'performanceReports', permission: 'reports' },
        { path: '/financial-reports', icon: DollarSign, labelKey: 'financialReports', permission: 'reports' },
        { path: '/reports', icon: FileBarChart, labelKey: 'reports', permission: 'reports' },
        { path: '/analytics', icon: BarChart3, labelKey: 'analytics', permission: 'analytics' },
        { path: '/charts-analytics', icon: PieChart, labelKey: 'chartsAnalytics', permission: 'charts_analytics' },
        { path: '/email-reports', icon: Mail, labelKey: 'emailReports', permission: 'reports' },
        { path: '/scheduled-reports', icon: CalendarClock, labelKey: 'scheduledReports', permission: 'reports' },
        { path: '/leave-reports', icon: Calendar, labelKey: 'leaveReports', permission: 'reports' },
        { path: '/print-profit-reports', icon: Printer, labelKey: 'printProfitReports', permission: 'print_orders' },
        { path: '/referral-analytics', icon: Gift, labelKey: 'referralAnalytics', permission: 'reports' },
        { path: '/referral-challenge', icon: Trophy, labelKey: 'referralChallenge', permission: 'reports' },
        { path: '/services', icon: PackageOpen, labelKey: 'services', permission: 'services' },
      ]
    },
    admin: {
      titleKey: 'systemManagement',
      icon: Wrench,
      items: [
        { path: '/users-management', icon: Menu, labelKey: 'usersManagement', permission: 'users_management' },
        { path: '/company-settings', icon: Settings, labelKey: 'companySettings', permission: 'company_settings' },
        { path: '/backups', icon: Database, labelKey: 'backup', permission: 'backup' },
        { path: '/audit-log', icon: Shield, labelKey: 'auditLog', permission: 'audit_log' },
        { path: '/system-settings', icon: Server, labelKey: 'systemSettings', permission: 'users_management' },
        { path: '/settings/business-activities', icon: Settings, labelKey: 'businessActivities', permission: 'company_settings' },
        { path: '/sse-monitor', icon: Server, labelKey: 'sseMonitor', permission: 'users_management' },
        { path: '/security-settings', icon: Shield, labelKey: 'securitySettings', permission: 'security_integration' },
        { path: '/branches', icon: GitBranch, labelKey: 'branches', permission: 'company_settings' },
        { path: '/documentation', icon: FileText, labelKey: 'documentation', permission: 'documentation' },
        { path: '/notifications', icon: Bell, labelKey: 'notifications', permission: 'notifications' },
        { path: '/notifications-system', icon: BellRing, labelKey: 'notificationsSystem', permission: 'users_management' },
        { path: '/smart-alerts', icon: BellRing, labelKey: 'smartAlerts', permission: 'users_management' },
        { path: '/approvals', icon: CheckCircle, labelKey: 'approvals', permission: 'approvals' },
        { path: '/internal-tickets', icon: Ticket, labelKey: 'internalTickets', permission: 'users_management' },
        { path: '/meeting-rooms', icon: DoorOpen, labelKey: 'meetingRooms', permission: 'users_management' },
        { path: '/sms', icon: MessageSquare, labelKey: 'smsNotifications', permission: 'users_management' },
      ]
    },
    // التواصل والدردشة - متاح للجميع
    communication: {
      titleKey: 'communication',
      icon: MessageCircle,
      items: [
        { path: '/internal-chat', icon: MessageCircle, labelKey: 'internalChat', permission: 'ai_tools' },
        { path: '/chat', icon: MessageCircle, labelKey: 'chat', permission: 'ai_tools' },
      ]
    },
    // خدمات المكتب - متاح لجميع الموظفين الذين لديهم الصلاحية
    officeServices: {
      titleKey: 'officeServices',
      icon: Coffee,
      items: [
        { path: '/office-services', icon: ShoppingCart, labelKey: 'officeServicesOrder', permission: 'office_services' },
      ]
    },
    // New Modules - Operations & Production
    operationsAndProduction: {
      titleKey: 'operationsAndProduction',
      icon: Video,
      items: [
        { path: '/studio-booking', icon: Camera, labelKey: 'studioBooking', permission: 'studio_booking' },
        { path: '/video-production', icon: Video, labelKey: 'videoProduction', permission: 'video_production' },
        { path: '/content-management', icon: FileEdit, labelKey: 'contentManagement', permission: 'content_management' },
        { path: '/translation', icon: Languages, labelKey: 'translationServices', permission: 'translation' },
        { path: '/equipment', icon: WrenchIcon, labelKey: 'equipmentManagement', permission: 'equipment' },
        { path: '/ip-management', icon: Copyright, labelKey: 'ipManagement', permission: 'ip_management' },
      ]
    },
    // New Modules - Business Development
    businessDevelopment: {
      titleKey: 'businessDevelopment',
      icon: Rocket,
      items: [
        { path: '/crm', icon: Target, labelKey: 'crm', permission: 'leads' },
        { path: '/bookings', icon: CalendarCheck, labelKey: 'bookings', permission: 'bookings' },
        { path: '/okr', icon: Target, labelKey: 'okrObjectives', permission: 'okr' },
        { path: '/tenders', icon: Trophy, labelKey: 'tenders', permission: 'tenders' },
        { path: '/events', icon: PartyPopper, labelKey: 'eventsManagement', permission: 'events' },
        { path: '/outdoor-ads', icon: Radio, labelKey: 'outdoorAds', permission: 'outdoor_ads' },
        { path: '/influencers', icon: UserCheck, labelKey: 'influencers', permission: 'influencers' },
        { path: '/launches', icon: Rocket, labelKey: 'launches', permission: 'launches' },
        { path: '/web-projects', icon: Globe, labelKey: 'webProjects', permission: 'web_projects' },
      ]
    },
    // New Modules - HR & Loyalty
    hrAdvanced: {
      titleKey: 'gamification',
      icon: Gamepad2,
      items: [
        { path: '/training', icon: GraduationCap, labelKey: 'training', permission: 'training' },
        { path: '/internal-review', icon: UserCheck, labelKey: 'internalReview', permission: 'internal_review' },
        { path: '/sop', icon: BookOpen, labelKey: 'sopProcedures', permission: 'sop' },
        { path: '/gamification', icon: Gamepad2, labelKey: 'gamification', permission: 'gamification' },
        { path: '/loyalty', icon: Heart, labelKey: 'loyaltyProgram', permission: 'loyalty' },
        { path: '/commissions', icon: Percent, labelKey: 'commissions', permission: 'commissions' },
        { path: '/referrals', icon: Share, labelKey: 'referrals', permission: 'referrals' },
        { path: '/complaints', icon: AlertTriangle, labelKey: 'complaints', permission: 'complaints' },
      ]
    }
  };

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  // تصفية العناصر حسب الصلاحيات + حسب الوحدات المفعّلة للمستأجر
  // في وضع legacy (مستأجر لم يختر أنشطة بعد) تمر كل العناصر، لذا سلوك
  // Al-Bareeq الحالي يبقى كما هو تماماً حتى تختار أنشطة الشركة من الإعدادات.
  const filterByPermission = (items) => {
    return items.filter(item =>
      hasPermission(item.permission) && isPermissionActive(item.permission)
    );
  };

  // التحقق من ظهور المجموعة
  const shouldShowGroup = (groupItems) => {
    return filterByPermission(groupItems).length > 0;
  };

  return (
    <>
      {/* زر القائمة - مخفي على الموبايل لأننا نستخدم MobileHeader */}
      <button
        onClick={toggleSidebar}
        className="hidden fixed top-4 right-4 z-50 p-2 bg-primary text-white rounded-md"
        data-testid="sidebar-toggle-btn"
      >
        {isOpen ? <X size={24} /> : <Menu size={24} />}
      </button>

      {/* Overlay للموبايل */}
      {isOpen && (
        <div 
          className="lg:hidden fixed inset-0 bg-black/60 z-[90]"
          onClick={() => setIsOpen(false)}
        />
      )}

      <div
        className={`fixed bg-[#1e3a8a] text-white shadow-2xl overflow-hidden
          top-0 right-0 h-screen w-72 lg:w-64
          transition-transform duration-300 ease-in-out
          ${isOpen ? 'translate-x-0' : 'translate-x-full'}
          lg:translate-x-0
          z-[100] lg:z-[70]
        `}
        data-testid="sidebar"
      >
        <div className="flex flex-col h-full">
          {/* Header - مخفي على الموبايل لأن لدينا MobileHeader */}
          <div className="p-4 border-b border-blue-700">
            <div className="flex items-center gap-3">
              <img
                src="https://customer-assets.emergentagent.com/job_design-agency-erp/artifacts/f17phjvg_%D9%84%D9%88%D9%83%D9%88%20%D8%B4%D8%B1%D9%83%D8%A9%20%D8%A8%D8%B1%D9%8A%D9%82.png"
                alt="شركة البريق"
                className="w-10 h-10 object-contain bg-white rounded-lg p-1"
              />
              <div className="flex-1">
                <h1 className="text-lg font-bold font-cairo">شركة البريق</h1>
                <p className="text-xs text-blue-200">للتصميم والدعاية والإعلان</p>
              </div>
              {/* زر إغلاق للموبايل */}
              <button 
                onClick={() => setIsOpen(false)}
                className="lg:hidden p-2 hover:bg-white/10 rounded-lg"
              >
                <X size={20} />
              </button>
            </div>
            <div className="mt-2 hidden lg:block">
              <LanguageSelector />
            </div>
          </div>

          {/* User Info */}
          <div className="px-4 py-3 border-b border-blue-700 bg-blue-800/30">
            <div className="text-sm">
              <p className="font-semibold font-cairo truncate">{user?.full_name}</p>
              <p className="text-xs text-blue-200 truncate">{user?.email}</p>
              <span className="inline-block mt-1 px-2 py-0.5 text-xs bg-accent/20 text-accent rounded-full">
                {getRoleName(user?.role)}
              </span>
            </div>
          </div>

          {/* Navigation */}
          <nav className="flex-1 overflow-y-auto p-3 pb-20" style={{ WebkitOverflowScrolling: 'touch' }}>
            {/* العناصر الرئيسية */}
            <ul className="space-y-1 mb-3">
              {filterByPermission(menuGroups.main).map((item) => (
                <MenuItem
                  key={item.path}
                  {...item}
                  isActive={location.pathname === item.path}
                  onClick={() => setIsOpen(false)}
                />
              ))}
            </ul>

            {/* العملاء والمشاريع */}
            {shouldShowGroup(menuGroups.clients.items) && (
              <CollapsibleSection
                icon={menuGroups.clients.icon}
                titleKey={menuGroups.clients.titleKey}
                defaultOpen={false}
                hasActiveChild={hasActiveInGroup(menuGroups.clients.items.map(i => i.path))}
              >
                {filterByPermission(menuGroups.clients.items).map((item) => (
                  <MenuItem
                    key={item.path}
                    {...item}
                    isActive={location.pathname === item.path}
                    onClick={() => setIsOpen(false)}
                  />
                ))}
              </CollapsibleSection>
            )}

            {/* المالية */}
            {shouldShowGroup(menuGroups.finance.items) && (
              <CollapsibleSection
                icon={menuGroups.finance.icon}
                titleKey={menuGroups.finance.titleKey}
                defaultOpen={false}
                hasActiveChild={hasActiveInGroup(menuGroups.finance.items.map(i => i.path))}
              >
                {filterByPermission(menuGroups.finance.items).map((item) => (
                  <MenuItem
                    key={item.path}
                    {...item}
                    isActive={location.pathname === item.path}
                    onClick={() => setIsOpen(false)}
                  />
                ))}
              </CollapsibleSection>
            )}

            {/* المخزون والموردين */}
            {shouldShowGroup(menuGroups.inventory.items) && (
              <CollapsibleSection
                icon={menuGroups.inventory.icon}
                titleKey={menuGroups.inventory.titleKey}
                defaultOpen={false}
                hasActiveChild={hasActiveInGroup(menuGroups.inventory.items.map(i => i.path))}
              >
                {filterByPermission(menuGroups.inventory.items).map((item) => (
                  <MenuItem
                    key={item.path}
                    {...item}
                    isActive={location.pathname === item.path}
                    onClick={() => setIsOpen(false)}
                  />
                ))}
              </CollapsibleSection>
            )}

            {/* الطباعة */}
            {shouldShowGroup(menuGroups.printing.items) && (
              <CollapsibleSection
                icon={menuGroups.printing.icon}
                titleKey={menuGroups.printing.titleKey}
                defaultOpen={false}
                hasActiveChild={hasActiveInGroup(menuGroups.printing.items.map(i => i.path))}
              >
                {filterByPermission(menuGroups.printing.items).map((item) => (
                  <MenuItem
                    key={item.path}
                    {...item}
                    isActive={location.pathname === item.path}
                    onClick={() => setIsOpen(false)}
                  />
                ))}
              </CollapsibleSection>
            )}

            {/* التسليم والسائقين */}
            {shouldShowGroup(menuGroups.delivery.items) && (
              <CollapsibleSection
                icon={menuGroups.delivery.icon}
                titleKey={menuGroups.delivery.titleKey}
                defaultOpen={false}
                hasActiveChild={hasActiveInGroup(menuGroups.delivery.items.map(i => i.path))}
              >
                {filterByPermission(menuGroups.delivery.items).map((item) => (
                  <MenuItem
                    key={item.path}
                    {...item}
                    isActive={location.pathname === item.path}
                    onClick={() => setIsOpen(false)}
                  />
                ))}
              </CollapsibleSection>
            )}

            {/* الموارد البشرية */}
            {shouldShowGroup(menuGroups.hr.items) && (
              <CollapsibleSection
                icon={menuGroups.hr.icon}
                titleKey={menuGroups.hr.titleKey}
                defaultOpen={false}
                hasActiveChild={hasActiveInGroup(menuGroups.hr.items.map(i => i.path))}
              >
                {filterByPermission(menuGroups.hr.items).map((item) => (
                  <MenuItem
                    key={item.path}
                    {...item}
                    isActive={location.pathname === item.path}
                    onClick={() => setIsOpen(false)}
                  />
                ))}
              </CollapsibleSection>
            )}

            {/* التسويق */}
            {shouldShowGroup(menuGroups.marketing.items) && (
              <CollapsibleSection
                icon={menuGroups.marketing.icon}
                titleKey={menuGroups.marketing.titleKey}
                defaultOpen={false}
                hasActiveChild={hasActiveInGroup(menuGroups.marketing.items.map(i => i.path))}
              >
                {filterByPermission(menuGroups.marketing.items).map((item) => (
                  <MenuItem
                    key={item.path}
                    {...item}
                    isActive={location.pathname === item.path}
                    onClick={() => setIsOpen(false)}
                  />
                ))}
              </CollapsibleSection>
            )}

            {/* التقارير والإحصائيات */}
            {shouldShowGroup(menuGroups.reports.items) && (
              <CollapsibleSection
                icon={menuGroups.reports.icon}
                titleKey={menuGroups.reports.titleKey}
                defaultOpen={false}
                hasActiveChild={hasActiveInGroup(menuGroups.reports.items.map(i => i.path))}
              >
                {filterByPermission(menuGroups.reports.items).map((item) => (
                  <MenuItem
                    key={item.path}
                    {...item}
                    isActive={location.pathname === item.path}
                    onClick={() => setIsOpen(false)}
                  />
                ))}
              </CollapsibleSection>
            )}

            {/* الذكاء الاصطناعي */}
            {shouldShowGroup(menuGroups.ai.items) && (
              <CollapsibleSection
                icon={menuGroups.ai.icon}
                titleKey={menuGroups.ai.titleKey}
                defaultOpen={false}
                hasActiveChild={hasActiveInGroup(menuGroups.ai.items.map(i => i.path))}
              >
                {filterByPermission(menuGroups.ai.items).map((item) => (
                  <MenuItem
                    key={item.path}
                    {...item}
                    isActive={location.pathname === item.path}
                    onClick={() => setIsOpen(false)}
                  />
                ))}
              </CollapsibleSection>
            )}

            {/* أدوات متقدمة */}
            {shouldShowGroup(menuGroups.advancedTools.items) && (
              <CollapsibleSection
                icon={menuGroups.advancedTools.icon}
                titleKey={menuGroups.advancedTools.titleKey}
                defaultOpen={false}
                hasActiveChild={hasActiveInGroup(menuGroups.advancedTools.items.map(i => i.path))}
              >
                {filterByPermission(menuGroups.advancedTools.items).map((item) => (
                  <MenuItem
                    key={item.path}
                    {...item}
                    isActive={location.pathname === item.path}
                    onClick={() => setIsOpen(false)}
                  />
                ))}
              </CollapsibleSection>
            )}

            {/* العمليات والإنتاج */}
            {shouldShowGroup(menuGroups.operationsAndProduction.items) && (
              <CollapsibleSection
                icon={menuGroups.operationsAndProduction.icon}
                titleKey={menuGroups.operationsAndProduction.titleKey}
                defaultOpen={false}
                hasActiveChild={hasActiveInGroup(menuGroups.operationsAndProduction.items.map(i => i.path))}
              >
                {filterByPermission(menuGroups.operationsAndProduction.items).map((item) => (
                  <MenuItem
                    key={item.path}
                    {...item}
                    isActive={location.pathname === item.path}
                    onClick={() => setIsOpen(false)}
                  />
                ))}
              </CollapsibleSection>
            )}

            {/* تطوير الأعمال */}
            {shouldShowGroup(menuGroups.businessDevelopment.items) && (
              <CollapsibleSection
                icon={menuGroups.businessDevelopment.icon}
                titleKey={menuGroups.businessDevelopment.titleKey}
                defaultOpen={false}
                hasActiveChild={hasActiveInGroup(menuGroups.businessDevelopment.items.map(i => i.path))}
              >
                {filterByPermission(menuGroups.businessDevelopment.items).map((item) => (
                  <MenuItem
                    key={item.path}
                    {...item}
                    isActive={location.pathname === item.path}
                    onClick={() => setIsOpen(false)}
                  />
                ))}
              </CollapsibleSection>
            )}

            {/* التحفيز والولاء */}
            {shouldShowGroup(menuGroups.hrAdvanced.items) && (
              <CollapsibleSection
                icon={menuGroups.hrAdvanced.icon}
                titleKey={menuGroups.hrAdvanced.titleKey}
                defaultOpen={false}
                hasActiveChild={hasActiveInGroup(menuGroups.hrAdvanced.items.map(i => i.path))}
              >
                {filterByPermission(menuGroups.hrAdvanced.items).map((item) => (
                  <MenuItem
                    key={item.path}
                    {...item}
                    isActive={location.pathname === item.path}
                    onClick={() => setIsOpen(false)}
                  />
                ))}
              </CollapsibleSection>
            )}

            {/* إدارة النظام - للمدراء فقط */}
            {/* التواصل والدردشة */}
            {shouldShowGroup(menuGroups.communication.items) && (
              <>
                <div className="my-3 border-t border-blue-700/50"></div>
                <CollapsibleSection
                  icon={menuGroups.communication.icon}
                  titleKey={menuGroups.communication.titleKey}
                  defaultOpen={false}
                  hasActiveChild={hasActiveInGroup(menuGroups.communication.items.map(i => i.path))}
                >
                  {filterByPermission(menuGroups.communication.items).map((item) => (
                    <MenuItem
                      key={item.path}
                      {...item}
                      isActive={location.pathname === item.path}
                      onClick={() => setIsOpen(false)}
                    />
                  ))}
                </CollapsibleSection>
              </>
            )}

            {/* خدمات المكتب - متاح لكل الموظفين */}
            {shouldShowGroup(menuGroups.officeServices.items) && (
              <>
                <div className="my-3 border-t border-blue-700/50"></div>
                <CollapsibleSection
                  icon={menuGroups.officeServices.icon}
                  titleKey={menuGroups.officeServices.titleKey}
                  defaultOpen={false}
                  hasActiveChild={hasActiveInGroup(menuGroups.officeServices.items.map(i => i.path))}
                >
                  {filterByPermission(menuGroups.officeServices.items).map((item) => (
                    <MenuItem
                      key={item.path}
                      {...item}
                      isActive={location.pathname === item.path}
                      onClick={() => setIsOpen(false)}
                    />
                  ))}
                </CollapsibleSection>
              </>
            )}

            {canAccessAdminPages(user?.role, user?.permissions) && shouldShowGroup(menuGroups.admin.items) && (
              <>
                <div className="my-3 border-t border-blue-700/50"></div>
                <CollapsibleSection
                  icon={menuGroups.admin.icon}
                  titleKey={menuGroups.admin.titleKey}
                  defaultOpen={false}
                  hasActiveChild={hasActiveInGroup(menuGroups.admin.items.map(i => i.path))}
                >
                  {filterByPermission(menuGroups.admin.items).map((item) => (
                    <MenuItem
                      key={item.path}
                      {...item}
                      isActive={location.pathname === item.path}
                      onClick={() => setIsOpen(false)}
                    />
                  ))}
                </CollapsibleSection>
              </>
            )}
            
            {/* مسافة إضافية في الأسفل */}
            <div className="h-20"></div>
          </nav>

          {/* Logout - ثابت في الأسفل */}
          <div className="absolute bottom-0 left-0 right-0 p-3 border-t border-blue-700 bg-[#1e3a8a] space-y-2">
            {/* رابط بوابة العملاء - للمدراء فقط */}
            {canAccessAdminPages(user?.role, user?.permissions) && (
              <a
                href="/portal/login"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 w-full px-3 py-2 text-accent hover:bg-accent/20 rounded-lg font-cairo text-sm transition-colors group"
                data-testid="customer-portal-sidebar-link"
              >
                <Users size={18} />
                <span className="flex-1">بوابة العملاء</span>
                <ExternalLink size={14} className="opacity-50 group-hover:opacity-100" />
              </a>
            )}
            
            <Button
              onClick={handleLogout}
              variant="ghost"
              className="w-full justify-start gap-3 text-white hover:bg-red-600 hover:text-white font-cairo text-sm"
              data-testid="logout-btn"
            >
              <LogOut size={18} />
              <span>{t('logout')}</span>
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export const Layout = ({ children }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { isDark, toggleTheme } = useTheme();
  
  return (
    <div className={`flex min-h-screen ${isDark ? 'bg-slate-900' : 'bg-slate-50'}`}>
      {/* Mobile Header */}
      <MobileHeader 
        isMenuOpen={isMobileMenuOpen} 
        onMenuToggle={() => setIsMobileMenuOpen(!isMobileMenuOpen)} 
      />
      
      {/* Sidebar */}
      <Sidebar isOpen={isMobileMenuOpen} setIsOpen={setIsMobileMenuOpen} />
      
      {/* Main Content */}
      <div className="flex-1 lg:mr-64 relative z-0">
        {/* Top Bar with Search and Theme Toggle */}
        <div className={`hidden lg:flex items-center justify-between px-6 py-3 ${isDark ? 'bg-slate-800 border-slate-700' : 'bg-white border-gray-200'} border-b sticky top-0 z-40`}>
          <GlobalSearch />
          <div className="flex items-center gap-3">
            <NotificationBell isDark={isDark} />
            <NotificationsPanel />
            <LanguageSelector />
            <button
              onClick={toggleTheme}
              className={`p-2 rounded-lg transition-colors ${isDark ? 'bg-slate-700 hover:bg-slate-600 text-yellow-400' : 'bg-gray-100 hover:bg-gray-200 text-gray-600'}`}
              title={isDark ? 'الوضع الفاتح' : 'الوضع الداكن'}
              data-testid="theme-toggle"
            >
              {isDark ? <Sun size={20} /> : <Moon size={20} />}
            </button>
          </div>
        </div>
        
        <main className={`p-4 lg:p-6 pt-20 lg:pt-4 pb-24 lg:pb-6 ${isDark ? 'text-slate-200' : ''}`} data-testid="main-content">
          {children}
        </main>
      </div>
      
      {/* Bottom Navigation for Mobile */}
      <BottomNav onMenuClick={() => setIsMobileMenuOpen(true)} />
    </div>
  );
};
